import { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { supabase } from '@/services';
import { Link, useNavigate } from 'react-router-dom';
import { Spinner } from '@/components/ui/spinner';
import { toast } from '@/hooks/use-toast';
import { useAuth } from '@/providers/auth-provider';
import AuthLayout from '@/layouts/auth-layout';
import { ArrowLeftIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();
  const { session } = useAuth();
  const { t } = useTranslation();

  useEffect(() => {
    if (session?.user) {
      navigate('/');
    }
  }, [session, navigate]);

  const doReset = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setLoading(true);
    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/reset-password`,
      });
      if (error) {
        toast({
          title: 'Error',
          description: error.message,
          variant: 'destructive',
        });
        console.log(error);
      } else {
        setSuccess(true);
      }
    } catch (err) {
      console.log('Catch block:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout>
      <form onSubmit={doReset} className="space-y-4 w-full flex flex-col items-center">
        {loading && <Spinner size={'large'} />}
        <div className="space-y-2 w-full max-w-sm">
          {success ? (
            <p>{t('resetLinkSent')}</p>
          ) : (
            <Input
              id="email"
              type="email"
              placeholder={t('enterYourEmail')}
              value={email}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setEmail(e.target.value)
              }
              required
            />
          )}
        </div>
        <div className="flex flex-col items-center justify-center w-full">
          {!success && (
            <Button type="submit" className=" w-fit">
              {t('resetPassword')}
            </Button>
          )}
          <Link
            to="/login"
            className=" flex hover:underline mt-4 cursor-pointer text-center"
          >
            <ArrowLeftIcon className="h-4 w-4 mr-2" /> {t('backToLogin')}
          </Link>
        </div>
      </form>
    </AuthLayout>
  );
};
